// GENERATED from registry/sites.yaml by scripts/gen_sites_js.py. Do not edit.
//
// `python3 scripts/gen_sites_js.py --check` fails CI if this file and the YAML disagree, so an
// edit here is an edit that will be reverted. Change the YAML. data/sample.js handKeptSites()
// turns these rows into records.

/** Every registry/sites.yaml row, in file order. `record: false` rows are coordinates other rows anchor on, not records. */
export const SITES = [
  {
    "id": "dss-14",
    "display": "Goldstone DSS-14",
    "class": "dish",
    "world": "earth",
    "lat": 35.4259,
    "lon": -116.8895,
    "alt_m": 1001,
    "diameter_m": 70,
    "doing": "The 70-metre dish at Goldstone, California."
  },
  {
    "id": "dss-25",
    "display": "Goldstone DSS-25",
    "class": "dish",
    "world": "earth",
    "lat": 35.3376,
    "lon": -116.8754,
    "alt_m": 960,
    "diameter_m": 34,
    "doing": "A 34-metre dish at Goldstone."
  },
  {
    "id": "dss-43",
    "display": "Canberra DSS-43",
    "class": "dish",
    "world": "earth",
    "lat": -35.4024,
    "lon": 148.9813,
    "alt_m": 689,
    "diameter_m": 70,
    "doing": "The only dish that can still send commands to Voyager 2."
  },
  {
    "id": "dss-63",
    "display": "Madrid DSS-63",
    "class": "dish",
    "world": "earth",
    "lat": 40.4312,
    "lon": -4.248,
    "alt_m": 865,
    "diameter_m": 70,
    "doing": "The 70-metre dish outside Madrid."
  },
  {
    "id": "saturn-v-lc-39a",
    "display": "Saturn V, Launch Complex 39A",
    "class": "pad",
    "world": "earth",
    "lat": 28.6083,
    "lon": -80.6044,
    "alt_m": 0,
    "aliases": [
      "Saturn 5",
      "LC-39A",
      "Apollo launch pad"
    ],
    "liftoffs": [
      "1968-12-21T12:51:00Z",
      "1969-07-16T13:32:00Z",
      "1972-12-07T05:33:00Z"
    ],
    "doing": "The pad twelve Saturn V rockets left from, 1967 to 1973. The rocket is drawn only in the day before each launch listed here: choose one to go there."
  },
  {
    "id": "shuttle-lc-39b",
    "display": "Space Shuttle, Launch Complex 39B",
    "class": "pad",
    "world": "earth",
    "lat": 28.6272,
    "lon": -80.6208,
    "alt_m": 0,
    "aliases": [
      "Space Shuttle",
      "LC-39B",
      "STS"
    ],
    "liftoffs": [
      "1988-09-29",
      "1990-04-24",
      "2006-12-10"
    ],
    "doing": "A pad 53 Space Shuttle flights left from, the last in 2006. The stack is drawn only on the day of each launch listed here: choose one to go there."
  },
  {
    "id": "baikonur-site-1",
    "display": "Baikonur Site 1, Gagarin's Start",
    "class": "pad",
    "world": "earth",
    "lat": 45.92028,
    "lon": 63.34222,
    "alt_m": 0,
    "aliases": [
      "Gagarin's Start",
      "Site 1",
      "Site 1/5",
      "Baikonur Site 1",
      "Vostok 1 pad"
    ],
    "doing": "Gagarin's Start, Site 1 at Baikonur: Sputnik 1 left from here in 1957, Vostok 1 in 1961, Voskhod 2 in 1965 (the first spacewalk)."
  },
  {
    "id": "apollo-11",
    "display": "Apollo 11 landing site",
    "class": "surface",
    "world": "moon",
    "lat": 0.67416,
    "lon": 23.47314,
    "shape": "lunar-module",
    "aliases": [
      "Tranquility Base"
    ],
    "doing": "Where people first stood on another world, in July 1969. The descent stage is still there."
  },
  {
    "id": "apollo-14",
    "display": "Apollo 14 landing site",
    "class": "surface",
    "world": "moon",
    "lat": -3.64589,
    "lon": 342.52806,
    "shape": "lunar-module",
    "doing": "Fra Mauro, February 1971. Alan Shepard hit two golf balls here and they are still lying where they stopped."
  },
  {
    "id": "apollo-16",
    "display": "Apollo 16 landing site",
    "class": "surface",
    "world": "moon",
    "lat": -8.9734,
    "lon": 15.5011,
    "shape": "lunar-module",
    "doing": "Descartes, April 1972. Charlie Duke left a photograph of his family face-up in the dust beside the lander."
  },
  {
    "id": "apollo-17",
    "display": "Apollo 17 landing site",
    "class": "surface",
    "world": "moon",
    "lat": 20.1911,
    "lon": 30.7723,
    "shape": "lunar-module",
    "doing": "The last place people have stood on another world, in December 1972."
  },
  {
    "id": "change-4",
    "display": "Chang'e 4",
    "class": "surface",
    "world": "moon",
    "lat": -45.4561,
    "lon": 177.5885,
    "shape": "lander",
    "aliases": [
      "Change 4",
      "Yutu-2"
    ],
    "doing": "The first landing on the far side of the Moon, in 2019."
  },
  {
    "id": "beresheet",
    "display": "Beresheet impact site",
    "class": "surface",
    "world": "moon",
    "lat": 32.5956,
    "lon": 19.3496,
    "record": false,
    "doing": "Where an Israeli lander hit Mare Serenitatis in April 2019, carrying a stack of nickel discs."
  },
  {
    "id": "surveyor-1",
    "display": "Surveyor 1, Oceanus Procellarum",
    "class": "surface",
    "world": "moon",
    "lat": -2.4745,
    "lon": 316.6602,
    "shape": "lander",
    "doing": "The first American spacecraft to land softly on the Moon, in June 1966. It sent home more than 11 000 pictures."
  },
  {
    "id": "surveyor-3",
    "display": "Surveyor 3, Oceanus Procellarum",
    "class": "surface",
    "world": "moon",
    "lat": -3.0162,
    "lon": 336.582,
    "shape": "lander",
    "doing": "Landed in April 1967. Two and a half years later the Apollo 12 crew walked over and took its camera home."
  },
  {
    "id": "apollo-12",
    "display": "Apollo 12 landing site",
    "class": "surface",
    "world": "moon",
    "lat": -3.0128,
    "lon": 336.5781,
    "shape": "lunar-module",
    "doing": "Pete Conrad and Alan Bean, November 1969. They landed about 180 m from Surveyor 3, a robot that had been there since 1967."
  },
  {
    "id": "luna-16",
    "display": "Luna 16, Mare Fecunditatis",
    "class": "surface",
    "world": "moon",
    "lat": -0.5137,
    "lon": 56.3638,
    "shape": "lander",
    "doing": "The first robot to bring Moon rock to Earth, in September 1970. It drilled up 101 grams of soil."
  },
  {
    "id": "lunokhod-1",
    "display": "Lunokhod 1, Mare Imbrium",
    "class": "surface",
    "world": "moon",
    "lat": 38.315,
    "lon": 324.9919,
    "shape": "rover",
    "aliases": [
      "Luna 17"
    ],
    "doing": "The first rover on another world. It drove 10.5 km across Mare Imbrium in 1970 and 1971, and this is where it stopped."
  },
  {
    "id": "apollo-15",
    "display": "Apollo 15 landing site",
    "class": "surface",
    "world": "moon",
    "lat": 26.13239,
    "lon": 3.6333,
    "shape": "lunar-module",
    "doing": "Hadley Rille, July 1971. The first car on the Moon drove here, and Dave Scott dropped a hammer and a feather to watch them land together."
  },
  {
    "id": "lunokhod-2",
    "display": "Lunokhod 2, Le Monnier crater",
    "class": "surface",
    "world": "moon",
    "lat": 25.8323,
    "lon": 30.9222,
    "shape": "rover",
    "aliases": [
      "Luna 21"
    ],
    "doing": "A Soviet rover that landed in January 1973 and drove at least 37 km over hills and rilles in four months. It stopped here."
  },
  {
    "id": "change-3",
    "display": "Chang'e 3, Mare Imbrium",
    "class": "surface",
    "world": "moon",
    "lat": 44.1214,
    "lon": 340.4883,
    "shape": "lander",
    "aliases": [
      "Change 3",
      "Yutu"
    ],
    "doing": "China's first Moon landing, in December 2013, and the first soft landing on the Moon since 1976. It carried the Yutu rover."
  },
  {
    "id": "yutu",
    "display": "Yutu rover, Mare Imbrium",
    "class": "surface",
    "world": "moon",
    "lat": 44.1208,
    "lon": 340.4878,
    "shape": "rover",
    "aliases": [
      "Yutu 1",
      "Jade Rabbit"
    ],
    "doing": "China's first Moon rover. It rolled off Chang'e 3 in December 2013, drove 114 metres and stopped here, about 20 metres from its lander."
  },
  {
    "id": "change-5",
    "display": "Chang'e 5, Oceanus Procellarum",
    "class": "surface",
    "world": "moon",
    "lat": 43.0576,
    "lon": 308.0839,
    "shape": "lander",
    "aliases": [
      "Change 5"
    ],
    "doing": "Collected 1 731 grams of soil and rock in December 2020, the first Moon samples brought to Earth since 1976."
  },
  {
    "id": "chandrayaan-3",
    "display": "Chandrayaan-3 Vikram lander",
    "class": "surface",
    "world": "moon",
    "lat": -69.3741,
    "lon": 32.32,
    "shape": "lander",
    "aliases": [
      "Pragyan",
      "Statio Shiv Shakti"
    ],
    "doing": "India's first landing on the Moon, in August 2023, and the first anywhere near its south pole. The Pragyan rover drove off from here."
  },
  {
    "id": "slim",
    "display": "SLIM, near Shioli crater",
    "class": "surface",
    "world": "moon",
    "lat": -13.316,
    "lon": 25.251,
    "shape": "lander",
    "aliases": [
      "Moon Sniper"
    ],
    "doing": "Japan's first Moon landing, January 2024. It came down about 55 m from its target, then tipped over onto its nose."
  },
  {
    "id": "im-1",
    "display": "Odysseus (IM-1), near Malapert A",
    "class": "surface",
    "world": "moon",
    "lat": -80.13,
    "lon": 1.44,
    "shape": "lander",
    "aliases": [
      "Intuitive Machines"
    ],
    "doing": "The first private spacecraft to land on the Moon and the first American one since 1972, in February 2024. It tipped over as it landed."
  },
  {
    "id": "change-6",
    "display": "Chang'e 6, Apollo basin",
    "class": "surface",
    "world": "moon",
    "lat": -41.6385,
    "lon": 206.0148,
    "shape": "lander",
    "aliases": [
      "Change 6"
    ],
    "doing": "Scooped and drilled 1 935 grams of soil and rock in June 2024: the first samples ever brought back from the far side of the Moon."
  },
  {
    "id": "blue-ghost-1",
    "display": "Blue Ghost 1, Mare Crisium",
    "class": "surface",
    "world": "moon",
    "lat": 18.562,
    "lon": 61.81,
    "shape": "lander",
    "aliases": [
      "Firefly"
    ],
    "doing": "Firefly's lander, March 2025: the first fully successful commercial Moon landing. It worked for a whole lunar day and into the night."
  },
  {
    "id": "jezero",
    "display": "Perseverance, Jezero crater",
    "class": "surface",
    "world": "mars",
    "lat": 18.4446,
    "lon": 77.4509,
    "shape": "rover",
    "aliases": [
      "Octavia E. Butler Landing"
    ],
    "doing": "A rover the size of a car, collecting rock samples in a crater that was once a river delta."
  },
  {
    "id": "ingenuity",
    "display": "Ingenuity, Valinor Hills",
    "class": "surface",
    "world": "mars",
    "lat": 18.4973,
    "lon": 77.3225,
    "shape": "lander",
    "aliases": [
      "Mars Helicopter",
      "Airfield Chi"
    ],
    "doing": "The first aircraft to fly on another world: 72 flights from 2021 to 2024. It stands where the last one ended."
  },
  {
    "id": "gale",
    "display": "Curiosity, Gale crater",
    "class": "surface",
    "world": "mars",
    "lat": -4.5895,
    "lon": 137.4417,
    "shape": "rover",
    "aliases": [
      "Bradbury Landing"
    ],
    "doing": "Driving up a mountain of layered rock since 2012."
  },
  {
    "id": "elysium",
    "display": "InSight, Elysium Planitia",
    "class": "surface",
    "world": "mars",
    "lat": 4.5024,
    "lon": 135.6234,
    "shape": "lander",
    "doing": "Listened to marsquakes until its solar panels were covered in dust in 2022."
  },
  {
    "id": "utopia",
    "display": "Zhurong, Utopia Planitia",
    "class": "surface",
    "world": "mars",
    "lat": 25.066,
    "lon": 109.925,
    "shape": "rover",
    "doing": "China's first Mars rover, landed in 2021."
  },
  {
    "id": "viking-1",
    "display": "Viking 1, Chryse Planitia",
    "class": "surface",
    "world": "mars",
    "lat": 22.27,
    "lon": 312.05,
    "shape": "lander",
    "aliases": [
      "Thomas Mutch Memorial Station"
    ],
    "doing": "Landed in July 1976 and sent back pictures and weather reports for more than six years, until November 1982."
  },
  {
    "id": "viking-2",
    "display": "Viking 2, Utopia Planitia",
    "class": "surface",
    "world": "mars",
    "lat": 47.6673,
    "lon": 134.2809,
    "shape": "lander",
    "aliases": [
      "Gerald Soffen Memorial Station"
    ],
    "doing": "Landed in September 1976. In the Martian winter its cameras saw a thin coat of frost on the ground around it."
  },
  {
    "id": "mars-pathfinder",
    "display": "Mars Pathfinder, Ares Vallis",
    "class": "surface",
    "world": "mars",
    "lat": 19.086,
    "lon": 326.763,
    "shape": "lander",
    "aliases": [
      "Sojourner",
      "Carl Sagan Memorial Station"
    ],
    "doing": "Bounced down on airbags on 4 July 1997 and let out Sojourner, the first rover to drive on Mars."
  },
  {
    "id": "spirit",
    "display": "Spirit, Gusev crater",
    "class": "surface",
    "world": "mars",
    "lat": -14.5692,
    "lon": 175.4729,
    "shape": "rover",
    "aliases": [
      "Columbia Memorial Station"
    ],
    "doing": "Where Spirit landed in January 2004. Built for 90 Martian days, it drove 7.7 km and worked for six years."
  },
  {
    "id": "opportunity",
    "display": "Opportunity, Meridiani Planum",
    "class": "surface",
    "world": "mars",
    "lat": -1.9462,
    "lon": 354.4734,
    "shape": "rover",
    "aliases": [
      "Challenger Memorial Station"
    ],
    "doing": "Where Opportunity rolled to a stop inside a small crater in January 2004. It went on to drive 45 km in more than 14 years."
  },
  {
    "id": "phoenix",
    "display": "Phoenix, Vastitas Borealis",
    "class": "surface",
    "world": "mars",
    "lat": 68.22,
    "lon": 234.25,
    "shape": "lander",
    "aliases": [
      "Green Valley"
    ],
    "doing": "Landed on the arctic plains of Mars in May 2008 and dug down to water ice a few centimetres under the soil."
  },
  {
    "id": "mars-3",
    "display": "Mars 3, Ptolemaeus crater",
    "class": "surface",
    "world": "mars",
    "lat": -45.058,
    "lon": 202.031,
    "shape": "lander",
    "doing": "The first soft landing on Mars, in December 1971. It fell silent after 20 seconds; in 2013 HiRISE photographed what may be its parachute."
  },
  {
    "id": "huygens",
    "display": "Huygens, Adiri",
    "class": "surface",
    "world": "titan",
    "lat": -10.573,
    "lon": 167.665,
    "shape": "lander",
    "aliases": [
      "Huygens probe",
      "Huygens landing site"
    ],
    "doing": "ESA's probe came down on Titan in January 2005, the first landing in the outer Solar System, and sent home pictures of rounded pebbles."
  },
  {
    "id": "vostok-1-landing",
    "display": "Vostok 1 landing site, near Smelovka",
    "class": "feature",
    "world": "earth",
    "lat": 51.27068,
    "lon": 45.99727,
    "diameter_m": 1000,
    "aliases": [
      "Smelovka",
      "Gagarin landing site",
      "Vostok 1 landing"
    ],
    "doing": "A field 26 km south-west of Engels, Saratov region, where Vostok 1's capsule came down on 12 April 1961. A monument marks the spot."
  },
  {
    "id": "voskhod-2-landing",
    "display": "Voskhod 2 landing site, taiga north-east of Perm",
    "class": "feature",
    "world": "earth",
    "lat": 59.5667,
    "lon": 55.4667,
    "diameter_m": 2000,
    "aliases": [
      "Voskhod 2 landing",
      "Leonov landing site",
      "Belyayev landing site",
      "Berezniki taiga"
    ],
    "doing": "Forest and deep snow about 75 km from Perm, where Voskhod 2 came down on 19 March 1965, 386 km off its field. Belyayev and Leonov spent two nights there."
  },
  {
    "id": "edwards-afb-runway-23",
    "display": "Edwards Air Force Base, lakebed runway 23",
    "class": "feature",
    "world": "earth",
    "lat": 34.9,
    "lon": -117.883,
    "diameter_m": 8000,
    "aliases": [
      "Edwards AFB",
      "Rogers Dry Lake",
      "STS-1 landing site",
      "Columbia landing site"
    ],
    "doing": "The dry lake bed where Columbia landed on 14 April 1981 at the end of STS-1, on runway 23. Several of the early Space Shuttle flights ended here."
  },
  {
    "id": "copernicus",
    "display": "Copernicus crater",
    "class": "feature",
    "world": "moon",
    "lat": 9.62,
    "lon": 339.92,
    "diameter_m": 96070,
    "aliases": [
      "Copernicus"
    ],
    "doing": "A crater 96 km across and nearly 4 km deep, young for the Moon, its bright rays crossing the plains. Best at sunrise or sunset, when its walls cast shadows."
  },
  {
    "id": "tycho",
    "display": "Tycho crater",
    "class": "feature",
    "world": "moon",
    "lat": -43.3,
    "lon": 348.78,
    "diameter_m": 85290,
    "aliases": [
      "Tycho"
    ],
    "doing": "A crater 85 km across with a central peak, young enough that its rays of bright ejecta still run across much of the near side."
  },
  {
    "id": "shackleton",
    "display": "Shackleton crater",
    "class": "feature",
    "world": "moon",
    "lat": -89.67,
    "lon": 129.78,
    "diameter_m": 20920,
    "aliases": [
      "Shackleton"
    ],
    "doing": "A crater 21 km across beside the Moon's south pole. Sunlight only grazes its rim, and its floor never sees the Sun at all."
  },
  {
    "id": "moon-south-pole",
    "display": "The Moon's south pole",
    "class": "feature",
    "world": "moon",
    "lat": -90,
    "lon": 0,
    "aliases": [
      "Lunar south pole",
      "South pole of the Moon"
    ],
    "doing": "Where the Moon's axis comes out. The Sun never climbs more than a degree or two here, so peaks stay lit for most of a month and crater floors stay dark."
  }
];
